import React from 'react'
import { Route, Switch } from 'react-router-dom'
import RouteWithSubRoutes from 'components/common/RouteWithSubRoutes/RouteWithSubRoutes'

import Settings from './Settings'
import User from './User'
import Billing from './Billing'
import Hooks, { hooksPath } from './Hooks'
import Subscriptions, { path as subscriptionsPath } from './Subscriptions'
import ChangePassword, { path as changePasswordPath } from './ChangePassword'
// import Mailboxes from './Mailboxes'
// import Schedules from './Schedules'

import styles from "./Styles.scss";
import NotFoundRoute from "../NotFound";


const ContentComponent = () => (
  <div className={styles.Page}>
    <div className={styles.PageLayout}>
      <Route path="/settings" component={Settings} />

      <div className={styles.TabContent}>
        <Switch>
          <Route exact path="/settings/user" component={User} />
          <Route exact path="/settings/billing" component={Billing} />
          <Route path={hooksPath} component={Hooks} />
          <Route path={subscriptionsPath} component={Subscriptions} />
          <Route path={changePasswordPath} component={ChangePassword} />
          {/*<Route path="/settings/mailboxes" component={Mailboxes} />*/}
          {/*<Route path="/settings/schedules" component={Schedules} />*/}

          <Route component={NotFoundRoute} /> {/* 404 */}
        </Switch>
      </div>
    </div>
  </div>
)

export default () => (
  <RouteWithSubRoutes
    path="/settings"
    baseComponent={ContentComponent}
    subRoutes={[
      /^\/settings/,
    ]}
  />
)
